<template>
    <Background
        :backPath="'/home'">

        <a-input-search
             v-model="searchContent"
             size="large"
             placeholder="搜索目标订单的前一单"
             class="search"
             @search="onSearch"
         />
        <div class="search-hint-area">
            <div
                v-if="searching"
                class="search-hint">
                <div
                    v-on:click="cleanSearch"
                    class="clean-search">
                    清空搜索 <a-icon type="close" />
                </div>
            </div>
        </div>


        <ListView
            v-if="searching"
            ref="searchList"
            :titles="titles"
            :columnWidths="columnWidths"
            :columnCells="columnCells"
            :clickCallback="clickReviewer"
            :listWidth="50"
        />
        <ListView
            v-else
            ref="userList"
            :titles="titles"
            :columnWidths="columnWidths"
            :columnCells="columnCells"
            :fetchCallback="fetchUserList"
            :clickCallback="clickReviewer"
            :addCallback="addReviewer"
            :listWidth="50"
        />

        <!-- <div
             v-if="amount > 0"
             class="merchant-amount">
             识别系统总数: {{ amount }}
             </div> -->

        <AddReviewerDialog ref="dialog"/>
    </Background>
</template>

<script>
 import Vue from 'vue';
 import Background from "./Background.vue"
 import ListView from "./ListView.vue"
 import AddReviewerDialog from "./AddReviewerDialog.vue"
 import message from "ant-design-vue/lib/message";
 import InputSearch from "ant-design-vue/lib/input/Search";

 import { isEmptyOrWhitespace } from "../util/utils.js"

 Vue.component(InputSearch.name, InputSearch);

 export default {
     name: 'ReviewerManage',
     data() {
         return {
             amount: 0,
             searchContent: "",
             searchNumber: 0,
             searching: false,
             titles: ["ID", "姓名", "登录账号", "类型", "初级测验", "高级测验", "上月识别数", "上月复核", "复核准确率"],
             columnWidths: [10, 10, 15, 10, 10, 10, 15, 10, 10],
             columnCells: [
                 { value: "UserId",
                   style: ""
                 },
                 { value: "DisplayName",
                   style: "text-align: center;"
                 },
                 { value: "Username",
                   style: "text-align: center;"
                 },
                 { value: "RoleName",
                   style: "text-align: center;"
                 },
                 { value: "LevelOneScore",
                   style: "text-align: center;"
                  },
                { value: "LevelTwoScore",
                  style: "text-align: center;"
                 },
                 { value: "Count",
                    style: "text-align: center;"
                 },
               { value: "ReviewScore",
                 style: "text-align: center;"
               },
               { value: "ReviewPercent",
                 style: "text-align: center;"
               },
             ]
         }
     },
     components: {
         Background,
         ListView,
         AddReviewerDialog
     },
     computed: {
     },
     mounted() {
         // this.fetchAmount()
     },
     methods: {
         fetchAmount() {
             const url = `${process.env.VUE_APP_API_SERVER}/marker/total`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 if (response.Total) {
                     this.amount = response.Total
                 } else {
                     console.log("fetchAmount error: ", response)
                 }
             })
         },
         clickReviewer(item) {
             sessionStorage.setItem("clickReviewerInfo", JSON.stringify(item))

             this.$router.push("/reviewerInfo")
         },
         addReviewer() {
             this.$refs.dialog.show()
         },
         fetchUserList(offset, callback) {
             const url = `${process.env.VUE_APP_API_SERVER}/marker?offset=${offset}`;
             var accessToken = localStorage.getItem('accessToken')

             fetch(url, {
                 method: 'GET',
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }
             ).then(res => res.json()
             ).catch(error => {
                 console.log("Error: ", error)
             }).then(response => {
                 for (var i=0; i < response.length; i++) {
                     if (response[i].Role == 25) {
                         response[i].RoleName = "管理员"
                     } else if (response[i].Role == 26) {
                         response[i].RoleName = "长识别"
                     } else if (response[i].Role == 27) {
                         response[i].RoleName = "短识别"
                     } else if (response[i].Role == 28) {
                         response[i].RoleName = "测验"
                     } else if (response[i].Role == 29) {
                         response[i].RoleName = "复核"
                     }
                 }

                 callback(response)
             })
         },
         onSearch() {
            this.searching = !isEmptyOrWhitespace(this.searchContent)

            if (this.searching) {
                this.doSearch()
            }
        },
        doSearch() {
            const url = `${process.env.VUE_APP_API_SERVER}/marker/search-order?q=${this.searchContent}`;
            var accessToken = localStorage.getItem('accessToken')

            fetch(url, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Access-Token': accessToken
                })
            }
            ).then(res => res.json()
            ).catch(error => {
                console.log("Error: ", error)
                message.error("查询失败: " + error)
            }).then(response => {
                 console.log(response)
                 if (response.error) {
                      message.error("查询失败: " + response.error)
                  } else {
                      message.success( this.searchContent + " 前一单是" + response, 120)
                  }
            })
        },
        cleanSearch() {
            this.searching = false
            this.searchContent = ""
        }
     },
 }
</script>

<style scoped>
 .search {
     width: 400px;
 }

 .search-hint-area {
     height: 50px;
 }

 .search-content {
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     color: #666;
     font-size: 16px;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .search-hint {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
 }

 .clean-search {
     background-color: #F9D878;
     color: #666;
     font-size: 16px;
     border-radius: 5px;
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     cursor: pointer;
 }

 .merchant-amount {
     width: 100%;
     margin-top: 10px;
     color: #999;
 }
</style>
